import * as Yup from 'yup';
import { Program } from '../../../common/models';

export function useValidationSchema() {
  return Yup.object<Program>().shape({
    name: Yup.string().nullable().required(),
  });
}
